<template>
  <div class="message-card">
    <q-img style="width=100% ;height=100%" :src="srcUrl">
      <div
        class="absolute-full flex flex-center text-dark text-center text-bold"
      >
        <q-card class="q-pa-sm"
          ><p class="color-dark">{{ displayMessage }}</p>

          <q-btn
            @click="
              this.$router.push({
                path: buttonRoute,
                query: {
                  route: buttonQuery,
                },
              })
            "
            class="q-mt-md"
            color="secondary"
            >{{ buttonText }}</q-btn
          >
        </q-card>
      </div>
    </q-img>
  </div>
</template>

<script>
export default {
  name: "MessageCard",
  props: {
    displayMessage: {
      type: String,
      default: "No Data Found!",
    },
    buttonText: {
      type: String,
      default: "No Button Text",
    },
    buttonRoute: {
      type: String,
      // default: "/",
    },
    buttonQuery: {
      type: String,
    },
    srcUrl: {
      type: String,
      default: () => "images/blur-image/blurFullpage.png",
    },
  },
  setup() {
    return {};
  },
};
</script>
